import styled from 'styled-components';

export const ConfirmationNoticeStyle = styled.div`
  z-index: 9;
  .go-back {
    width: 56px;
    display: flex;
  }
  .button-container {
    display: flex;
    justify-content: space-between;
  }
`;
